import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface BleDeviceRequest {
    deviceId: string;
    deviceName: string;
    stationId: number;
    deviceType?: string;
    iotData?: string;
}

export interface StationCommandRequest {
    stationId: number;
    command: string;
    payload?: any;
}

@Injectable({
    providedIn: 'root'
})
export class BleDialogService {
    private openBleDialogSubject = new Subject<BleDeviceRequest>();
    openBleDialog$ = this.openBleDialogSubject.asObservable();

    private stationCommandSubject = new Subject<StationCommandRequest>();
    stationCommand$ = this.stationCommandSubject.asObservable();

    requestOpenBleDialog(device: BleDeviceRequest) {
        this.openBleDialogSubject.next(device);
    }

    sendStationCommand(request: StationCommandRequest) {
        this.stationCommandSubject.next(request);
    }
}
